angular.module('gym.pos', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.pos', {
    abstract: true,
    url: '/pos',
    template: '<ui-view>'
  });
}]);
